// src/components/PP2Exams.js
import React from 'react';

import ExamsList from './ExamsListPerYear';

const SecondaryFullSetExaminations = ({ isLoggedIn, clearToken }) => {
    const items = [
        { name: '2026 SECONDARY FULL SET EXAMINATIONS', year: 2026, bgColor: 'rgba(0, 0, 0, 0.2)', textColor:'rgb(0, 0, 0)', path: "secondary", value: "fullset/examinations" },
        { name: '2025 SECONDARY FULL SET EXAMINATIONS', year: 2025, bgColor: 'rgba(0, 0, 0, 0.1)', textColor: 'rgb(0, 0, 0)', path: "secondary", value: "fullset/examinations" },

    ];

    return (
       <>
    
        <ExamsList
           
            heading="SECONDARY SCHOOL FULL SET EXAMINATIONS SECTION"
            items={items}
            navigateTo="/secondary/fullset/examinations/download"
        />
       </>
    );
};

export default SecondaryFullSetExaminations;
